import { ApolloClient, InMemoryCache, ApolloLink, createHttpLink, } from "@apollo/client";
import { equal as uriEqual } from "uri-js";
import { dataIdFromObject } from "./dataIdFromObject";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { Capacitor } from "@capacitor/core";
import { getSecureStorageToken, removeSecureStorageToken, } from "./SecureStoragePluginFunctions";
export const LoginUri = new URL(`${window.location.origin}/security/login`).href.toString();
export const SecurityUri = new URL(`${window.location.origin}/security`).toString();
const apolloCache = new InMemoryCache({
    // cacheRedirects: CacheRedirects,
    dataIdFromObject,
    addTypename: true,
});
const authFailed = (error) => {
    if ("statusCode" in error &&
        (error.statusCode === 401 || error.statusCode === 403)) {
        return true;
    }
    return false;
};
const onLoginPage = () => {
    if (uriEqual(window.location.href, LoginUri, { tolerant: true })) {
        return true;
    }
    if (window.location.pathname.includes(SecurityUri)) {
        return true;
    }
    return false;
};
const logoutAndRedirect = () => {
    console.warn("Logging out and redirect to login");
    client
        .clearStore()
        .then(async () => await removeSecureStorageToken())
        .then(() => (window.location.href = LoginUri))
        .catch(() => (window.location.href = LoginUri));
};
export const errorHandler = ({ graphQLErrors, networkError, }) => {
    if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path, extensions }) => {
            console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
            if (extensions?.code == "AUTH_NOT_AUTHENTICATED" &&
                !onLoginPage()) {
                logoutAndRedirect();
            }
        });
    }
    if (networkError) {
        console.error(`[Network error]: ${networkError.message}`);
        if (authFailed(networkError) && !onLoginPage()) {
            logoutAndRedirect();
        }
    }
};
const authLink = setContext(async (_, { headers }) => {
    const token = await getSecureStorageToken();
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token.value}` : "",
        },
    };
});
function httpLinkOptions(platform) {
    // graphQl uri - if not web use base URI else use serve location (reverse proxy required for latter)
    const BaseApiUri = platform !== "web"
        ? new URL(`${window.argonBaseUrl}/graphql`).toString()
        : "/graphql";
    return {
        credentials: "same-origin",
        uri: BaseApiUri,
        headers: {
            "X-Interfi-Authorisation": "YWJjLWRlZi1naGktMzMzLTMzMy0zMzM=",
            Interfi: "1",
        },
    };
}
const httpLink = () => {
    const platform = Capacitor.getPlatform();
    return platform !== "web"
        ? authLink.concat(createHttpLink(httpLinkOptions(platform)))
        : createHttpLink(httpLinkOptions(platform));
};
const client = new ApolloClient({
    cache: apolloCache,
    link: ApolloLink.from([onError(errorHandler), httpLink()]),
});
export { client };
